import { Injectable } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { UserService } from "app/core/user/user.service";
import { User } from "app/models/user.model";
import { Observable, ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LanguagesService {
    /**
     * Objects
     */
    private _lang: ReplaySubject<string> = new ReplaySubject<string>(1);

    /**
     * Constructor
     * @param _userService 
     * @param _translocoService 
     */
    constructor(private _userService: UserService, private _translocoService: TranslocoService) {
        this._userService.user$
        .subscribe({
            next: (response: User) => {
                this.lang = 'el';
                this._translocoService.setActiveLang('el');
                if (response) {
                    if ( response.language && (response.language === 'el' || response.language === 'en') ) {
                        this.lang = response.language;
                        this._translocoService.setActiveLang(response.language);
                    }
                }                
            },
            error: er => {
                console.log(er);
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter for language
     */
    set lang(value: string) {
        // Store the value
        this._lang.next(value);
    }

    /**
     * Getter for language
     */
    get lang$(): Observable<string> {
        return this._lang.asObservable();
    }
}